export default "__VITE_ASSET__$pWJ4rOa__"